export default __webpack_public_path__ + "static/image14-500971ecca267eb7c93b409e1de6e043.gif";